import Vuex from 'vuex';

const {mapState, mapGetters, mapActions} = Vuex;
const _name = 'progression';

export const progressionComputed = {
	...mapState(_name, {
		currentTask: state => state.currentTask
	}),
	...mapGetters(_name, ['getCurrentTask',  'getProgressionIndex', 'getProgressionTaskIndex', 'getProgressionStars', 'getLastProgressionScore', 'getLastProgressionStars', 'getProgressionsLoggedOnDays', 'getPassesForProgression', 'getCurrentDay', 'getWasCompletedOnDay', 'getFinished', 'getTaskDay'])
};

export const progressionMethods = mapActions(_name, ['setCurrentTask', 'fetchProgressions', 'awardStars','saveProgressionInfo', 'moveToNextTask', 'checkProgression', 'checkForProgressionReset', 'logProgressionOnDate', 'checkIfFinished']);